import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  VDActions,
  SET_VDBUILDTYPE,
  SET_VDVISAID,
  SET_VDVISAINFO
} from '../actions/vd.actions';

import * as fromRoot from '../../../../app.reducer';

export interface VDState {
  buildType: any;
  visaId: number;
  visaInfo: any;
}

export interface State extends fromRoot.State {
  vd: VDState;
}

const InitialVDState: VDState = {
  buildType: null,
  visaId: null,
  visaInfo: null
};

export function vdReducer(state = InitialVDState, action: VDActions) {
  switch (action.type) {
    case SET_VDBUILDTYPE:
      return {
        ...state,
        buildType: action.payload
      };
    case SET_VDVISAID:
      return {
        ...state,
        visaId: action.payload
      };
    case SET_VDVISAINFO:
      return {
        ...state,
        visaInfo: action.payload ? JSON.parse(JSON.stringify(action.payload)) : null
      };
    default:
      return {
        ...state
      };
  }
}

export const getVDState = createFeatureSelector<VDState>('vd');
export const getVDBuildType = createSelector(getVDState, (state: VDState) => {
  return state.buildType ? state.buildType : null;
});
export const getVDVisaId = createSelector(getVDState, (state: VDState) => {
  return state.visaId ? state.visaId : null;
});
export const getVDVisaInfo = createSelector(getVDState, (state: VDState) => {
  return state.visaInfo ? state.visaInfo : null;
});
